module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-socials-links"
  }, [_c('ul', {
    staticClass: "c-socials-links__list o-list--none t-ffamily--simplon t-fweight--bold"
  }, [_c('li', {
    staticClass: "c-socials-links__list__title u-color--white"
  }, [_vm._v("Social")]), _vm._v(" "), _vm._l((_vm.$root.content.global.social.links), function(item, index) {
    return _c('li', [_c('a', {
      staticClass: "c-socials-links__link u-relative u-block u-fit-w",
      class: [_vm.$root.isTouch ? 'is-touch' : ''],
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_c('app-icon', {
      staticClass: "c-socials-links__link__icon u-valign-middle u-fill--white u-stroke--white",
      attrs: {
        "name": item.icon
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "u-marg-l-xxs u-valign-middle"
    }, [_vm._v(_vm._s(item.label))])], 1)])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-318f2f92"}!./src/scripts/components/app-socials-links/template.html
// module id = 459
// module chunks = 0